import PittaLogoSVG from 'src/assets/images/PittaLogo.svg';
import gradientArrowsSVG from 'src/assets/images/gradientArrows.svg';
import { composeURL } from 'src/utils/url';
import type { IdentityClient } from 'src/api/authApi';

import { Logo, LogoBox } from '../styled';

interface ClientLogoProps {
  client?: IdentityClient['client'];
}

const ClientLogo = ({ client }: ClientLogoProps) => {
  const hasClientLogo = Boolean(client?.logo);

  return (
    <Logo>
      <LogoBox>
        <img src={PittaLogoSVG} height={96} alt="Pitta" />
      </LogoBox>
      {hasClientLogo && client && (
        <>
          <img src={gradientArrowsSVG} alt="" aria-hidden="true" />
          <LogoBox>
            <img
              src={composeURL(client.logo)}
              height={40}
              style={{ padding: '0px 8px' }}
              alt={client.title || ''}
            />
          </LogoBox>
        </>
      )}
    </Logo>
  );
};

export default ClientLogo;
